import React, { useState, useContext, useCallback,useEffect } from 'react';
import styles from './search.module.css';
import SearchItem from './SearchItem';
import ForYou from './forYou/ForYou';
import SearchIcon1 from '../images/search-1.png';
import SearchIcon3 from '../images/search-3.png';
import SearchIcon4 from '../images/search-4.png';
import SearchIcon6 from '../images/search-6.png';
import hockey from '../images/hockey.png';
import Rugby from "../images/rugby.png"
import StayUpdated from '../RightSidebar/StayUpdated';
import { SearchContext } from '../../createContext/Search/SearchContext';
import debounce from 'lodash/debounce';
import News from './News/News';
import LiveScores from './News/LiveScore';
import FootballLiveScores from './News/FootballLiveScore';
import BaseballLiveScore from './News/BaseballLiveScore';
import RugbyLiveScore from './News/RugbyLiveScore';
import TennisLiveScore from './News/TennisLiveScore';
import cricketImg from '../images/cricket.jpg';
import basketballImg from '../images/BasketBall.svg';
import padel from "../images/padel.jpg";
import tennis from "../images/Tennis.jpeg";


function Search() {
  const [activeTab, setActiveTab] = useState("search");
  const [scoreTab, setScoreTab] = useState("cricket");

  const [searchQuery, setSearchQuery] = useState("");
  const { searchResults, loading, performSearch, clearSearch } = useContext(SearchContext);
  useEffect(() => {
    const storedScore = localStorage.getItem("score");
    console.log(storedScore);
    if (storedScore === "Football") {
      setSearchQuery("Football");
      setActiveTab("scores");
      setScoreTab(storedScore);
      localStorage.removeItem("score"); // Remove score after setting state
    }
  }, []);
  
  // Debounce search to avoid too many API calls
  const debouncedSearch = useCallback(
    debounce((query) => {
      if (query) {
        performSearch(query);
      } else {
        clearSearch();
      }
    }, 300),
    [performSearch, clearSearch]
  );

  const handleSearchInput = (e) => {
    const query = typeof e === 'string' ? e : e.target.value;
    setSearchQuery(query);
    if (query) {
      setActiveTab("foryou");
      debouncedSearch(query);
    } else {
      setActiveTab("search");
      clearSearch();
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleSearchItemClick = (label) => {
    setSearchQuery(label);
    handleSearchInput(label);
    setScoreTab(label);
  };

  const topSearchItems = [
    { src: SearchIcon6, label: 'Football' },
    { src: cricketImg, label: 'Cricket' },
    { src: 'https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/821e88d847b5201d52e7c0147fe292e7bb3edab3f3b889c4a68ec487c836455c?apiKey=f523408d85c94fc8913d645c993f4c42&', label: 'BasketBall' },
    { src: tennis, label: 'Tennis' },
    { src: padel, label: 'Padel' },
    { src: 'https://superblog.supercdn.cloud/site_cuid_clr6oh1no0006rmr89yhkxgu8/images/badminton-14280461280-1721457562607-compressed.jpg', label: 'Badminton' },
  ];

  // Sports for the scores tab with emojis
  const sportsScoreTabs = [
    { name: "Cricket", emoji: "🏏" },
    { name: "Football", emoji: "⚽" },
    { name: "Baseball", emoji: "⚾" },
    { name: "Rugby", emoji: "🏉" },
    { name: "Tennis", emoji: "🎾" },
    { name: "Badminton", emoji: "🏸" },
    { name: "TableTennis", emoji: "🏓" },
    { name: "BasketBall", emoji: "🏀" }
  ];

  const showDefaultContent = !searchQuery || activeTab === "search";

  return (
    <div className={styles.mainContent}>
      <div className={styles.topHeader}>
        <div className={styles.searchHeader}>
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f9dd340588aa26a402df13094927f7087d8cf1ec15bf9df0caa15aa4c44b8570"
            alt="search icon"
            className={styles.searchIcon}
          />
          <input 
            className={styles.input} 
            type="text" 
            placeholder="Search" 
            aria-label="Search"
            value={searchQuery}
            onChange={handleSearchInput}
          />
        </div>
      </div>

      {loading ? (
        <div className={styles.loading}>Loading...</div>
      ) : (
        <>
          {searchQuery ? (
            <>
              <div className={styles.searchToggle}>
                <button
                  className={activeTab === "foryou" ? styles.activeToggle : styles.inactiveToggle}
                  onClick={() => handleTabClick("foryou")}
                >
                  For you
                </button>
                <button
                  className={activeTab === "news" ? styles.activeToggle : styles.inactiveToggle}
                  onClick={() => handleTabClick("news")}
                >
                  News
                </button>
                <button
                  className={activeTab === "scores" ? styles.activeToggle : styles.inactiveToggle}
                  onClick={() => handleTabClick("scores")}
                >
                  Scores
                </button>
              </div>

              {activeTab === 'foryou' && <ForYou users={searchResults.users} posts={searchResults.posts} />}
              {activeTab === 'news' && <News searchQuery={searchQuery}/>}
              {activeTab === 'scores' && (
                <div className={`${styles.scrollableNavbar} space-x-2`}>
                  {sportsScoreTabs.map((sport) => (
                    <button
                      key={sport.name}
                      className={
                        scoreTab === sport.name 
                          ? styles.activeToggle 
                          : styles.inactiveToggle
                      }
                      onClick={() => setScoreTab(sport.name)}
                    >
                      {sport.emoji} {sport.name}
                    </button>
                  ))}
                </div>
              )}
             {activeTab==='scores' && <div className='ScoreCardWrapper'>
              {scoreTab === "Football" && <FootballLiveScores/>}
              {scoreTab === "Cricket" && <LiveScores/>}   
              {scoreTab === "Baseball" && <BaseballLiveScore/>} 
              {scoreTab === "Rugby" && <RugbyLiveScore/>}     
              {scoreTab === "Tennis" && <TennisLiveScore sport={'tennis'}/>}
              {scoreTab === "Badminton" && <TennisLiveScore sport={'badminton'}/>}        
              {scoreTab === "TableTennis" && <TennisLiveScore sport={'table-tennis'}/>}
              {scoreTab === "BasketBall" && <TennisLiveScore sport={'basketball'}/>} 
              </div>}

              {activeTab === 'foryou' && searchResults.users.length === 0 && searchResults.posts.length === 0 && (
                <div className={styles.noResults}>
                  No results found for "{searchQuery}"
                </div>
              )}
            </>
          ) : (
            // Default Content
            <>
              <div className={styles.heading}>Top Search</div>
              <div>
                <div className={styles.notificationWrapper}>
                  <div className={styles.gridContainer}>
                    {topSearchItems.map((item, index) => (
                      <SearchItem 
                        key={index} 
                        label={item.label} 
                        src={item.src}
                        onClick={() => handleSearchItemClick(item.label)}
                      />
                    ))}
                  </div>
                </div>
                <div className={styles.mobileOnly}>
                  <StayUpdated />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default Search;